
import { defineComponent, ref } from 'vue';
import { useClipboard } from 'vue-composable';
import MaterialIcon from '@/components/MaterialIcon.vue';
import Label from '@/components/form-controls/base/Label.vue';
import { debounce } from 'lodash';

export default defineComponent({
  name: 'CopyToClipboard',
  components: {
    MaterialIcon,
    Label
  },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { writeText } = useClipboard();
    const label = ref('Copy to Clipboard');

    const revertLabel = debounce(
      () => {
        label.value = 'Copy to Clipboard';
      },
      1500,
      {
        leading: false,
        trailing: true
      }
    );

    const copyToClipboard = () => {
      writeText(props.text);
      label.value = 'Copied!';
      revertLabel();
    };

    return {
      label,
      revertLabel,
      copyToClipboard
    };
  }
});
